import type { FaireProductEntity } from "../../entity_types/product";

export const p_3cq7ymywmu: FaireProductEntity = {
  token: "p_3cq7ymywmu",
  type: "product",
  name: "LAYERED CHAIN COIN PENDANT NECKLACE",
  brandToken: "b_tstkerjyhp",
  brandName: "Merveille",
  imageUrl:
    "https://cdn.faire.com/fastly/d8bbebbe0fbf1d16a46826eb1eb6e06910107abc937aff1ce5b29b60a96ba8ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1efa17ee8c2bea68167a93a57c9439d153d15f2a4becc16fcbd87bcb3cfd7d3b.jpeg",
    "https://cdn.faire.com/fastly/50098c2a4200b40f771ff886a805d7139091873dde39f7ad1dd6b0e3a34882a6.jpeg",
  ],
  priceDollars: 14.55,
  description:
    'Elevate your everyday jewelry assortment with this chic layered chain coin pendant necklace. Featuring a modern double-layer design with a sleek chain and a classic coin charm, this piece blends timeless elegance with contemporary style. Its versatile look makes it perfect for both casual wear and elevated outfits. A must-have staple for boutiques seeking on-trend, easy-to-style accessories.\nNecklace Length : 16" with 3" Extender\n\nFeatures\n• Double layered chain design for a trendy stacked look.\n• Classic coin pendant adds a timeless, vintage-inspired touch.\n• Lightweight and comfortable for all-day wear.\n• Perfect for layering or wearing alone as a statement piece.\n• Ideal for everyday styling, gifting, and boutique collections.\n\nlayered necklace, coin pendant necklace, gold layered chain, minimalist jewelry, trendy necklace, double chain necklace, dainty gold necklace, everyday jewelry, boutique jewelry, chic necklace, modern layered necklace, coin charm necklace, fashion jewelry',
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:44.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
